import { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';

import { PageLoader, PageLoaderWrapper } from 'shared-components/Loaders';

const SignIn = () => {
  const { loginWithRedirect } = useAuth0();
  const a0 = useAuth0();

  useEffect(() => {
    loginWithRedirect();
  }, []);

  return (
    <PageLoaderWrapper>
      <PageLoader />
    </PageLoaderWrapper>
  );
};

export default SignIn;
